import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const CustomFieldName = styled(Typography, {
  name: 'CustomFieldName',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  wordBreak: 'break-word',
  marginBottom: theme.spacing(-0.5),
}))
